import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  mainStack: {
    paddingTop: 24,
  },
}));
